<mat-toolbar class="mat-elevation-z8">
  Ändra busstur
</mat-toolbar>

<mat-dialog-content class="mt-3">

  <div class="my-2">
    <form [formGroup]="editOrderShuttleBusForm">
      <table>
        <tr>
          <td colspan="2">
            <mat-form-field appearance="outline">
              <mat-label>Buss</mat-label>
              <mat-select formControlName="busId">
                @for (bus of buses; track bus) {
                  <mat-option [value]="bus.busId">
                    {{ bus.name }} ({{ bus.seats }} platser)
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <mat-form-field appearance="outline">
              <mat-label>Busschaufför</mat-label>
              <mat-select formControlName="driverUserId">
                @for (driver of busDrivers; track driver) {
                  <mat-option [value]="driver.userId">
                    {{ driver.firstName }} {{ driver.lastName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td style="width:300px;">
            <mat-form-field appearance="outline">
              <mat-label>Startdatum för rutt</mat-label>
              <input matInput formControlName="startDate" [matDatepicker]="startDate">
              <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
              <mat-datepicker #startDate></mat-datepicker>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="outline">
              <mat-label>Starttid för rutt</mat-label>
              <input matInput type="time" value="{{startTime}}" formControlName="startTime">
            </mat-form-field>
          </td>
        </table>
      </form>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [disabled]="isDisabled" (click)="editOrderShuttleBus()">{{'spara' |
    uppercase}}</button>
    <button mat-button mat-dialog-close>STÄNG</button>
  </mat-dialog-actions>
  <p>&nbsp;</p>